/*
 * @Author: IT-Elin
 * @Date: 2022-04-20 11:10:41
 * @LastEditors: IT-Elin
 * @LastEditTime: 2022-04-20 16:05:12
 * @FilePath: \cbt2\src\js\util.js
 */
import {
  gameCode,
  activityCode,
  language,
  platform
} from "./config.js";
const trackGA = function (eventCategory, eventAction, eventLabel) {
  try {
    gtag("event", eventAction, {
      // Event parameters
      event_category: eventCategory,
      event_label: eventLabel,
      // ...
    });
  } catch (e) {}
};
const pushStateUrl = function (type, content) {
  if (type === "add") {
    var newUrl = window.location.href + content;
  } else {
    var newUrl = window.location.href.replace(content, "");
  }
  window.history.pushState("", "", newUrl); // 不刷新页面
};
const apiBasicParams = function () {
  return {
    gameCode,
    activityCode,
    language,
    platform,
  };
};
const apiLoginParams = function (
  userId,
  loginSign,
  loginTimestamp

) {
  return {
    gameCode,
    activityCode,
    language,
    platform,
    userId,
    loginSign,
    loginTimestamp,
  };
};
const msg = function (tip) {
  $(".pop-msg .msg").html(tip);
  $(".pop-msg").bPopup();
  $(".pop-msg").css("display", "table");
};
const getAreaCode = function (area, phone) {
  var reg = {
    65: /^[1-9]{1}[0-9]{7}$/,
    /* 新加坡 */
    60: /^[1-9]{1}[0-9]{8,9}$/,
    /* 马来西亚 */
  };
  var pat = reg[area];
  if (!pat) {
    return;
  }
  return pat.test(phone); /* test(),用于检测一个字符串是否匹配某个模式 */
};
const initGaEvent = function (gaInfo) {
  for (let element in gaInfo) {
    let item = gaInfo[element];
    (function (item) {
      $(element).click(function () {
        trackGA(item.category, item.action, item.label);
      });
    })(item);
  }
};
const getQueryString = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
  if (r != null) return unescape(r[2]);
  return "";
};
const isMac = function () {
  return navigator.userAgent.indexOf("Mac OS X") > 0;
};

const initLozad = function (lozads) {
  lozads.forEach(function (item) {
    $(item).addClass("lozad");
  });
  var observer = lozad(".lozad", {
    rootMargin: "10px 0px", // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
    enableAutoReload: true,
    load: function (el) {
      // console.log("loading element", el);
      $(el).addClass("loaded");
      // Custom implementation to load an element
      // e.g. el.src = el.getAttribute('data-src');
    },
  });
  observer.observe();
};
export {
  pushStateUrl,
  trackGA,
  apiBasicParams,
  apiLoginParams,
  msg,
  getAreaCode,
  initGaEvent,
  getQueryString,
  initLozad
};